<div class="comment-panel" *ngIf="allowComment && item" #commentThread>
    <div class="comment-header">
        <div class="header-text h6">Comments</div>
        <div class="action">
            <sync-icon-button
                *ngIf="!spinner && (isMdScreen ? !isCommentExpanded : isCommentExpanded)"
                iconName="refresh" size="large" [onClick]="getComments"></sync-icon-button>
            <sync-icon-button
                *ngIf="isMdScreen"
                size="small"
                [iconName]="isCommentExpanded ? 'chevron-up' : 'chevron-down'"
                [matTooltip]="isCommentExpanded ? 'Expand comments' : 'Collapse comments'"
                [onClick]="toggleCommentMd"
            ></sync-icon-button>
        </div>
        <div class="comment-expand-collapse">
            <sync-icon-button
                size="small"
                [iconName]="isCommentExpanded ? 'chevron-right' : 'chevron-left'"
                [matTooltip]="isCommentExpanded ? 'Collapse comments' : 'Expand comments'"
                [onClick]="toggleComment"
            ></sync-icon-button>
        </div>
    </div>
    <div class="comment-body" *ngIf="!spinner">
        <app-error *ngIf="errCode" [errcode]="errCode"/>

        <!-- COMMENT INPUT BOX -->
        <app-comment
            *ngIf="!errCode"
            [user]="user"
            [tempSession]="tempSession"
            [locId]="locId"
            [item]="item"
            [isInputBox]="true"
            [link]="link"
            [isCreatingNewComment]="isCreatingNewComment"
            (commentCreationEvent)="createComment($event)"
            (anonymousCreationEvent)="createAnonymousSession($event)"
        >
        </app-comment>
        <!-- / COMMENT INPUT BOX -->

        <!-- COMMENT THREADS -->
        <ng-container *ngFor="let comment of comments">
            <app-comment
                [comment]="comment"
                [user]="user"
                [tempSession]="tempSession"
                [cdk]="cdk"
                [ownerId]="ownerId"
                [item]="item"
                [locId]="locId"
                [link]="link"
                [publinkId]="publinkId"
                [signRequest]="signRequest"
                (commentEditionEvent)="updateComment($event)"
                (commentDeletionEvent)="deleteComment($event)"
                (commentGetEvent)="getComments()"
                (anonymousCreationEvent)="createAnonymousSession($event)"
            >
            </app-comment>
        </ng-container>
        <!-- / COMMENT THREADS -->
    </div>

    <div class="comments-loading-wrapper" *ngIf="spinner">
        <sync-spinner></sync-spinner>
    </div>
</div>

<!-- COMMENT IFRAME -->
<iframe
    id="sync-comment-cp-iframe"
    class="comment-cp-iframe"
    [src]="commentCPServiceHost"
    (error)="spinner=false;"
></iframe>
<!-- /COMMENT IFRAME -->
